import actions from './actions';

const initState = {
	dataSelectMissingWord: [],
	selectMissingWordDetail: null,
	totalItems: 0,
	loading: false,
};

export default function selectMissingWordReducer(state = initState, action) {
	switch (action.type) {
		case actions.GET_SELECT_MISSING_WORD:
			return { ...state, totalItems: 0, loading: true };
		case actions.GET_SELECT_MISSING_WORD_SUCCESS:
			let { data, totalItems } = action.payload;
			let res = data ? data : [];
			return { ...state, dataSelectMissingWord: res, totalItems, loading: false };

		case actions.GET_SELECT_MISSING_WORD_DETAIL:
			return { ...state, loading: true, totalItems: 0 };
		case actions.GET_SELECT_MISSING_WORD_DETAIL_SUCCESS: {
			let { data } = action.payload;
			let res = data ? data : {};
			return { ...state, selectMissingWordDetail: res, loading: false };
		}

		case actions.LISTENING_LOADING_FALSE: {
			return { ...state, loading: false };
		}

		default:
			return state;
	}
}
